module.exports = __webpack_public_path__ + "static/media/play-grey.6f1bd67a.svg";